import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  gtagClick(e) {
    const hasHref = e.currentTarget.href;
    e.preventDefault();
    const event = e.params.event;
    const lang = e.params.lang;
    gtag("event", event, {
      site_language: lang,
    });
    setTimeout(() => {
      window.location.href = hasHref;
    }, 150);
  }
}
